import { FetcherContext } from '@rogu/fetch';
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from 'react-query';

import {
  FileUploaderRequest,
  FileUploaderResponse,
  BucketData,
} from './fileUploaderEntity';
import {
  FileUploaderError,
  fileUploaderConfig,
  postFileUploader,
} from './fileUploaderService';

function useFileUploader(
  options?: UseMutationOptions<
    FileUploaderResponse,
    FileUploaderError,
    FileUploaderRequest
  >,
  fetcherContext?: FetcherContext,
) {
  return useMutation(
    (payload: FileUploaderRequest) => postFileUploader(payload, fetcherContext),
    options,
  );
}

function useUploaderBucket(
  options?: UseQueryOptions<
    Array<BucketData>,
    FileUploaderError,
    Array<BucketData>,
    'fileUploaderConfig'
  >,
) {
  return useQuery(
    'fileUploaderConfig',
    () => fileUploaderConfig().then((res) => res || []),
    options,
  );
}

export { useFileUploader, useUploaderBucket };
